import openSocket from 'socket.io-client';

import { store } from '../App'
import { setAvatarOptions, startSocialLogin, roomNotFoundError, LoginVersions } from '../components/store/actions/login'
import { startNextQuestion, showAnswer, showCommercial, showVoucherWinner, setFinalResults, questionTimerFinished } from '../components/store/actions/quiz'

import Storage from "../services/storage";

const ip = window.location.hostname;
const default_server = "127.0.0.1";
const socketURL = window.location.protocol + "//" + (ip === "localhost"? default_server : ip) + ":3000";


class SocketAPI {

    init () {
        console.log('init socket API', socketURL);


        this.isRoomJoined = false;        
        this.socket = openSocket(socketURL);
        this.addEventHandlers()
    }

    addEventHandlers () {
        this.socket.on("nextQuestion", this.nextQuestion.bind(this));
		this.socket.on("roomJoined", this.roomJoined.bind(this));
		this.socket.on("roomNotFound", this.roomNotFound.bind(this));
		this.socket.on("showCommercial", this.showCommercial.bind(this));
        this.socket.on("voucherWinner", this.voucherWinner.bind(this));
        this.socket.on("finalVoucherWinner", this.finalVoucherWinner.bind(this));
        this.socket.on("questionTimerFinished", this.questionTimerFinished.bind(this));
		this.socket.on("pushResults", this.showResult.bind(this));
		this.socket.on("endQuiz", this.endQuiz.bind(this));
    }

    /***
     * SOCKET EVENT HANDLERS
     */

    /**
     * Handles nextQuestion event - show next question
     */
    nextQuestion (question) {
		console.log("nextQuestion...", question);
		if (question) {
            question.answered = null;
            store.dispatch(startNextQuestion(question));
		}
    }

    /**
     * Confirmation from the API about connecting to the room
     * @param {Object[]} avatars - List of possible avatars 
     */
    roomJoined (avatars, sessionId) {
        this.isRoomJoined = true;
        Storage.setItem('PCSessionId', sessionId);


        const currentState = store.getState();
        if (currentState.login.loginType !== LoginVersions.USERNAME) {
            store.dispatch(setAvatarOptions(avatars))
            store.dispatch(startSocialLogin())    
        }else {
            console.log('call room joined handler!')
            if(this.roomJoinedHandler) this.roomJoinedHandler() 
        }
    }

    setRoomJoinedHandler (handler) {
        console.log('set room joined handler');
        this.roomJoinedHandler = handler;
    }

    /**
     * Handle error when roomCode is incorrect
     */
    roomNotFound () {
        console.log('roomNotFound')
        store.dispatch(roomNotFoundError())
    }

    /**
     * Shows a commercial 
     * @param {Object} result - ? 
     */
    showCommercial (result) {
        console.log('showCommercial')
        store.dispatch(showCommercial(result))
    }

    /**
     * Shows the winner of the voucher
     * @param {Object``} result 
     */
    voucherWinner (result) {
        console.log('voucherWinner')
        result.isFinal = false
        store.dispatch(showVoucherWinner(result))
    }


    finalVoucherWinner (result) {
        console.log('final voucher winner')
        result.isFinal = true
        store.dispatch(showVoucherWinner(result))
    }


    /**
     * Shows the results of a regular question
     * @param {Object} result 
     */
    showResult (result) {
        console.log("showResult::", result);
        store.dispatch(showAnswer(result));
    }

    questionTimerFinished () {
        store.dispatch(questionTimerFinished());
    }

    /**
     * Completes the quiz
     */
    endQuiz (results) {
        console.log("endQuiz:", results); 
        store.dispatch(setFinalResults(results));
        this.endQuizHandler();
    }

    addEndQuizHandler (handler) {
        this.endQuizHandler = handler;
    }

    endQuizHandler (results) {
        console.log('default endquiz handler!')
    }

    /**
     * Actions
     */

    /**
     * Joins the quiz
     */
    joinQuiz (roomCode, sessionId = null) {
        this.socket.emit("joinQuiz", {
            code: roomCode,
            sessionId: sessionId
        });
        Storage.setItem("PCSessionRoomCode", roomCode);
    }

    setPlayerName (code, name, isCustom = false) {
        this.socket.emit("setPlayerName", {
            code: code,
            name: name,
            isCustom: isCustom
        });
    }

    answerQuestion (question, answerId, roomCode, timeSpent) {
        this.socket.emit("answerQuestion", {
            "answer_id": answerId,
            "question_id": question.id,
            "user_id": "1",
            "code": roomCode,
            "time_spent": timeSpent
        })
    }

    /**
     * Enables the wake lock
     */
    enable () {
        console.log("[WAKE LOCK] - enable")
        this.noSleep.enable();
    }
}

export default new SocketAPI()


// WEBPACK FOOTER //
// ./src/services/socketAPI.js